import { OwcIcon } from "@one/react";
import { COLORS } from "../constants";
import { ScheduleEventProps } from "../types";
import { formatTimeRange, getBookingIcon } from "../utils/formattingUtils";

const ScheduleEvent: React.FC<ScheduleEventProps> = ({ event, siteTimezone }) => {
  const iconName = getBookingIcon(event.type || "", event);
  const timeRange = formatTimeRange(event.start, event.end, siteTimezone);
  const { isCurrentBooking } = event;

  const colors = isCurrentBooking ? COLORS.currentBooking : COLORS.otherBooking;

  return (
    <div
      style={{
        background: colors.background,
        color: colors.text,
        padding: "4px 8px",
        borderRadius: "4px",
        height: "100%",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        overflow: "hidden",
        opacity: isCurrentBooking ? 1 : 0.7,
      }}
    >
      <OwcIcon name={iconName} style={{ fontSize: "16px", color: colors.text }} />
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        {timeRange}
      </span>
    </div>
  );
};

export default ScheduleEvent;
